export const internalPostMessage = <T extends object>(
  value: T,
  targetOrigin: string = "*",
): void => {
  return window.parent.postMessage(JSON.stringify(value), targetOrigin);
};
